$(document).ready(function() {
    PageIsLoaded = true;
    if(typeof gdpr_delayed_function === 'function')
    {
        gdpr_delayed_function();
    }
});

$('#gdpr_accept_button, #gdpr_reject_button, .gdpr_opt_in_button').on('click', function () {
    var gdpr_notification_container = $('#gdpr_notification_container');

    // The reject button must NOT set gdpr_opted_in to true.
    var is_reject_click = this.id === 'gdpr_reject_button';

    if (is_reject_click) {
        setGDPRDecisionCookie('false');
    } else {
        setGDPRDecisionCookie('true');
    }

    // For a reject click we always want to hide the banner (the user made a
    // choice), even though checkCookiesForOptIn() will now return false.
    if (is_reject_click || checkCookiesForOptIn(gdpr_opt_in_cookie_name)) {
        $('body').removeClass("gdpr-shown"); //Only need to remove this class when a user clicks on the button because it shouldn't be added if they have already opted in
        gdpr_notification_container.fadeOut();
        /* For global header to move it back to the top */
        // Guard: .header_site may not exist on all pages. Skip the top
        // calculation rather than throwing "offset() is undefined".
        var $header_site = $('.header_site');
        if ($header_site.length) {
            var global_header_top = $header_site.offset().top + 25;
            $('.global_header').css("top", "calc( "+global_header_top+"px * 1 / var(--recite-me-zoom) )");
        } else {
            console.warn('gdpr-cookie-privacy.js: .header_site not found, skipping header top calculation.');
        }

        if (is_reject_click) {
            // Prevents from the popup to be shown at the start of every session.
            handlePolicyOptOut(true);
        } else {
            handlePolicyOptIn();
        }
    } else {
        console.log("Warning: Did not hide notification because it was not actually accepted! Maybe cookies are disabled?");
    }
});

$('.gdpr_opt_out_button').on('click', function () {
    deleteCookieFromAllPaths(gdpr_opt_in_cookie_name);
    handlePolicyOptOut();
});

function clearGDPRDecisionCookieEverywhere() {
    var expired = '=; expires=Thu, 01-Jan-1970 00:00:01 GMT;';
    var path_parts = location.pathname.split('/');
    var paths = [' path=/'];
    var current_path = ' path=';
    for (var i = 0; i < path_parts.length; i++) {
        current_path += ((current_path.substr(-1) !== '/') ? '/' : '') + path_parts[i];
        paths.push(current_path);
    }

    // Host-only variant (no domain attribute at all).
    for (var p = 0; p < paths.length; p++) {
        document.cookie = gdpr_opt_in_cookie_name + expired + paths[p] + ';';
    }

    // Every domain-attribute variant, from the full host down to the apex.
    // Use hostname (not host) so a port number, e.g. on localhost:4502,
    // never ends up inside a domain attribute - that would be invalid and
    // silently ignored by the browser.
    var domain_parts = window.location.hostname.split(".");
    while (domain_parts.length > 0) {
        var domain_attr = ' domain=' + domain_parts.join('.') + ';';
        for (var q = 0; q < paths.length; q++) {
            document.cookie = gdpr_opt_in_cookie_name + expired + domain_attr + paths[q] + ';';
        }
        domain_parts.shift();
    }
}

function setGDPRDecisionCookie(value) {
    clearGDPRDecisionCookieEverywhere();
    setOptInCookie(gdpr_opt_in_cookie_name, value, gdpr_opt_in_cookie_duration);
}

function setOptInCookie(name,value,days) {
    var expires = "";
    var domain = "";
    var host = window.location.host;
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    //This will allow non-flinders domains to have the cookies saved, like localhost and dev/test author
    if(host.indexOf(".flinders.edu.au") > 1 ) {
        domain = "; domain=.flinders.edu.au";
    }
    document.cookie = name + "=" + (value || "")  + expires + domain +"; path=/";
}

//Attempt to delete all cookies!
function deleteAllCookies() {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++)
    {
        var split_cookie =  cookies[i].split("=");
        deleteCookieFromAllPaths(split_cookie[0]);
    }
}

//Note: does not delete cookies that are httpOnly, but does try to delete for variants of the path. (Note: most of our cookies have path "/" set.)
function deleteCookieFromAllPaths(name) {
    var split_path_array = location.pathname.split('/');
    var current_path = ' path=';
    document.cookie = name + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT;';
    for (var i = 0; i < split_path_array.length; i++) {
        current_path += ((current_path.substr(-1) !== '/') ? '/' : '') + split_path_array[i];
        document.cookie = name + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT;' + current_path + ';';
    }
}
